import {storeToRefs} from 'pinia';
import {HYPERMARKET_CHANGE_FLAG_COOKIE, GLOBAL_BRANCH_SLUG} from '#shared/constants';
import {useStoryblokHypermarketsStore} from '~/stores/storyblokHypermarkets';

export default defineNuxtRouteMiddleware((to, from) => {
	const newBranch = Array.isArray(to.params.branch) ? to.params.branch[0] : to.params.branch;

	if (!newBranch || newBranch === GLOBAL_BRANCH_SLUG) {
		return;
	}

	const hypermarketsStore = useStoryblokHypermarketsStore();
	const {selectedHypermarket} = storeToRefs(hypermarketsStore);

	if (selectedHypermarket.value !== newBranch) {
		hypermarketsStore.setHypermarket(newBranch);
	}

	if (!from.name) {
		return;
	}

	const oldBranch = Array.isArray(from.params.branch) ? from.params.branch[0] : from.params.branch;
	const redirectFromGlobalBranch = oldBranch && newBranch && newBranch !== GLOBAL_BRANCH_SLUG && oldBranch === GLOBAL_BRANCH_SLUG;

	if (newBranch === oldBranch || !redirectFromGlobalBranch) {
		return;
	}

	const hypermarketChangedFlag = useCookie(HYPERMARKET_CHANGE_FLAG_COOKIE, {default: () => false});
	hypermarketChangedFlag.value = true;
});
